  const handleContactClick = (e, itemName, handleOpen) => {
    if (itemName === "Contact") {
      e.preventDefault();
      handleOpen(true);
    }
  };
export default handleContactClick;